<template>
  <div class="interested-company-card">
    <a :href="companyExperiencesPath" class="interested-company-card__link">
      <div class="interested-company-card__logo-wrap">
        <img
          v-if="company.square_logo"
          :src="company.square_logo"
          :alt="company.name"
          loading="lazy"
          class="interested-company-card__logo"
        />
        <div v-else class="interested-company-card__logo-placeholder" />
      </div>
      <p class="interested-company-card__category">{{ company.business_category_name }}</p>
      <p class="interested-company-card__name">{{ company.name }}</p>
      <StarRating :score="company.overall_score" class="interested-company-card__score" />
    </a>
    <button
      class="interested-company-card__follow-btn"
      @click.prevent="$emit('toggle-follow', { companyId: company.id, following: company.following })"
    >
      <InlineSvg v-if="company.following" :src="bellFillIcon" class="interested-company-card__follow-icon" />
      <InlineSvg v-else :src="bellIcon" class="interested-company-card__follow-icon" />
      {{ company.following ? 'お気に入り中' : 'お気に入り' }}
    </button>
  </div>
</template>

<script>
import bellIcon from '../images/bell.svg';
import bellFillIcon from '../images/bell_fill.svg';
import StarRating from './StarRating';

export default {
  name: 'InterestedCompanyCard',
  components: { StarRating },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      bellIcon,
      bellFillIcon,
    };
  },
  computed: {
    companyExperiencesPath() {
      return `/companies/${this.company.id}/experiences`;
    },
  },
};
</script>

<style lang="scss" scoped>
.interested-company-card {
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 16px 0 0;

  @media screen and (max-width: 768px) {
    padding: 0 8px 0 0;
  }
}

.interested-company-card__link {
  display: block;
  padding: 0 0 12px;
  text-decoration: none;
  color: inherit;
  flex: 1;
}

.interested-company-card__logo-wrap {
  width: 74px;
  height: 74px;
  margin: 0 auto 8px;
}

.interested-company-card__logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  vertical-align: middle;
}

.interested-company-card__logo-placeholder {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}

.interested-company-card__name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.interested-company-card__category {
  font-size: 10px;
  color: #6d7780;
  margin-bottom: 4px;
}

.interested-company-card__follow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  border-radius: 8px;
  padding: 6px 12px;
  color: #0085ce;
  background-color: #fff;
  border: 1px solid #0085ce;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
}

.interested-company-card__follow-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
</style>
